<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
          v-if="windowWidth <= 1200"
        />
        <comment class="ml-2" />
        <call-button class="ml-2" />
        <wallet class="ml-2" v-if="windowWidth > this.$store.state.windowsNavMin" />
        <!--  <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992"/>-->
        <vs-spacer />
        <i18n />
        <!--        <search-bar />-->
        <cart-drop-down />
        <chat-button />
        <notification-drop-down />
        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import I18n from './components/I18n.vue'
import CartDropDown from './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'
import Comment from '@/layouts/components/navbar/components/Comment'
import Wallet from '@/layouts/components/navbar/components/Wallet'
// import SearchBar from '@/layouts/components/navbar/components/SearchBar'
import CallButton from '@/layouts/components/navbar/components/CallButton'
import ChatButton from '@/layouts/components/navbar/components/ChatButton'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    ChatButton,
    Wallet,
    Comment,
    I18n,
    CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    CallButton
    // SearchBar
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {
        'text-white':
          (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') ||
          (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth) return 'navbar-full'
      return 'navbar-default'
    }
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>
